import React from 'react';
import desktopBanner from '@public/images/index/img-1.jpeg';
import mobileBanner from '@public/images/index/img-2.jpeg';

function Banner() {
  return (
    <>
      <div className="banner desktop-banner">
        <img src={desktopBanner} alt="中邮资管社会招聘" />
      </div>
      <div className="mobile-banner">
        <img src={mobileBanner} alt="中邮资管社会招聘" />
      </div>
    </>
  );
}

export default Banner;
